import React from 'react';

export default function ChartOverlay({ chartWidth }) {
  if (chartWidth <= 0) return null;

  return (
    <></>
    // <svg
    //   width={chartWidth}
    //   height={160}
    //   style={{
    //     position: 'absolute',
    //     left: 0,
    //     top: 0,
    //     pointerEvents: 'none',
    //     zIndex: 2
    //   }}
    // >
    //   {/* 左侧 30m 文本 */}
    //   <text
    //     x={25}
    //     y={20}
    //     fill="#fff"
    //     fontSize="14"
    //     fontWeight="400"
    //     textAnchor="start"
    //     alignmentBaseline="middle"
    //     style={{opacity: 0.9, fontFamily: 'inherit'}}
    //   >
    //     30m
    //   </text>
      
    //   {/* 正中线 */}
    //   <line
    //     x1={chartWidth / 2}
    //     y1={0}
    //     x2={chartWidth / 2}
    //     y2={160}
    //     stroke="#fff"
    //     strokeDasharray="4 4"
    //     strokeOpacity={0.4}
    //     strokeWidth={1}
    //   />
      
    //   {/* 中间 15m 文本 */}
    //   <text
    //     x={chartWidth / 2 + 20}
    //     y={20}
    //     fill="#fff"
    //     fontSize="14"
    //     fontWeight="400"
    //     textAnchor="middle"
    //     alignmentBaseline="middle"
    //     style={{opacity: 0.9, fontFamily: 'inherit'}}
    //   >
    //     15m
    //   </text>
      
    //   {/* 右侧1/3线 */}
    //   <line
    //     x1={chartWidth * 5 / 6}
    //     y1={0}
    //     x2={chartWidth * 5 / 6}
    //     y2={160}
    //     stroke="#fff"
    //     strokeDasharray="4 4"
    //     strokeOpacity={0.4}
    //     strokeWidth={1}
    //   />
      
    //   {/* 右侧 5m 文本 */}
    //   <text
    //     x={chartWidth / 6 * 5 + 30}
    //     y={20}
    //     fill="#fff"
    //     fontSize="14"
    //     fontWeight="400"
    //     textAnchor="end"
    //     alignmentBaseline="middle"
    //     style={{opacity: 0.9, fontFamily: 'inherit'}}
    //   >
    //     5m
    //   </text>
    // </svg>
  );
}
